/**
 * Base fields for all assets
 */
import { BaseDto, DtoId } from '../../../sj-orm/models/base.dto';
import { QuestionType } from '../../../sj-orm/models/form/question.dto';
import { TDtoWrapper } from '../../form-wrapper.types';

export type BaseAssetValuesTypes = Omit<BaseDto, 'id'> & {
  // insuranceAgreement?: DtoId;
  attachments?: DtoId[];
};

export type BaseAssetFieldsTypes = {
  // insuranceAgreement?: QuestionType.PICK_ARRAY_OF_DTO;
  attachments?: QuestionType.FILE_UPLOAD;
};

export type BaseAssetFieldsList = TDtoWrapper<BaseAssetValuesTypes, BaseAssetFieldsTypes>;

export const baseAssetFields: BaseAssetFieldsList = {
  // insuranceAgreement: {
  //   type: QuestionType.PICK_ARRAY_OF_DTO,
  //   label: 'forms_assets:common.inputs.insuranceAgreement.label',
  //   items: CollectionName.PRIVATE_DOCUMENTS,
  //   // dtoType: PrivateDocumentCategory.PUBLIC_AGREEMENTS,
  // },
  attachments: {
    type: QuestionType.FILE_UPLOAD,
    isMultiple: true,
    acceptFiles: 'assetPhotos',
    allowedActions: ['delete'],
    label: 'forms_assets:common.inputs.attachments.label',
  },
};
